export const LABELS_LIMIT = 5;
export const DEFAULT_MENU_SIZE = 20;
export const TRUNCATE_FROM_THRESHOLD = 50;

export enum ViewportType {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
}

export const DIVIDER_TYPE = {
  SOLID: 0,
  DASHED: 1,
  DOTTED: 2,
} as const;

export const ITEM_LAYOUT_TYPE = {
  STRIP: 0,
  CARD: 1,
} as const;

export const ITEM_IMAGE_PLACEMENT = {
  RIGHT: 0,
  LEFT: 1,
} as const;

export const ICON_POSITION = {
  LEFT: 0,
  RIGHT: 1,
  TOP: 2,
  BOTTOM: 3,
} as const;

export const HEADER_PLACEMENT = {
  BELOW: 0,
  ON: 1,
} as const;
